module.exports = __webpack_public_path__ + "assets/img/empty.f68cc916.png";